import { isArray, isObject } from '@/utils/is';

export function convertTableData(datas) {
  if (!Array.isArray(datas)) return;
  return datas.map(data => {
    const [name, avg, max, min] = data;
    return { name, avg, max, min };
  });
}

export function convertChartData(datas) {
  const { dimensions } = datas;
  delete datas.dimensions;
  return {
    names: Object.keys(datas),
    opts: Object.values(datas).map(e => ({ ...e, dimensions }))
  };
}

export function convertChartData2(datas, names) {
  const { dimensions, dataMap } = datas;
  return {
    names,
    opts: names.map((key, i) => ({ name: names[i], ordata: dataMap[key], dimensions }))
  };
}

function makeTableCfg(dimensions) {
  return isArray(dimensions) ? dimensions.map((e, i) => ({ prop: `${i}`, label: e })) : [];
}

/**
 * 转换为组件所需数据（设备总体运行情况）
 * 无设备数据时 返回 null
 * @param {*} data
 * @returns { Array<object>|null }
 */
export function convertData2(data) {
  if (!isObject(data)) return null;
  const arr = Object.keys(data);

  return arr.length
    ? arr.map(key => {
        const keys = isArray(data[key].avg.dataList) ? data[key].avg.dataList.map(e => e[0]) : [];
        return {
          sn: key,
          description: data[key].avg.summary,
          tableData: data[key].avg.dataList,
          thead: makeTableCfg(data[key].avg.dimensions),
          ...convertChartData2(data[key].ordata, keys)
        };
      })
    : null;
}

/**
 * 转换为组件所需数据（设备总体运行情况）
 * 无设备数据时 返回 null
 * @param {*} data
 * @returns { Array<object>|null }
 */
export function convertData(data) {
  if (!isObject(data)) return null;
  const arr = Object.keys(data);
  return arr.length
    ? arr.map(key => ({
        sn: key,
        tableData: convertTableData(data[key].avg.dataList),
        thead: data[key].avg.dimensions[0],
        ...convertChartData(data[key].ordata)
      }))
    : null;
}

/**
 * 转换为组件需要数据（分析总结）
 * @param {*} data
 * @returns {Array<object>}
 */
export function convertSummaryTable(data) {
  const props = 'name,avg,max,min,notes'.split(',');
  const convertArr = arr => {
    return arr.reduce((obj, e, i) => {
      obj[props[i]] = e;
      return obj;
    }, {});
  };
  return Object.keys(data).map(key => {
    const e = data[key];
    const thead = e.dimensions.map((label, i) => ({ prop: props[i], label }));
    const [name, notes] = e.dataList.pop();
    const fail = { name, notes };
    const list = e.dataList.map(convertArr);
    return {
      tableColumn: thead,
      tableData: list.concat(fail),
      type: key
    };
  });
}

/**
 * 转换为组件需要 设备报警情况数据
 * 图表无数据返回null
 * @param {object} alarm
 * @returns {object|null}
 */
export function convertAlarmData(alarm) {
  const x = alarm.dimensions[0];
  const y = alarm.dimensions[1];
  const data = alarm.dataList.reduce(
    (obj, e) => {
      obj.x.push(e[x]);
      obj.y.push(e[y]);
      return obj;
    },
    { x: [], y: [] }
  );
  if (!data.y.length) return null;
  return {
    tips: alarm.description,
    chartOpts: {
      xAxis: { data: data.x },
      yAxis: { type: 'value' },
      series: {
        data: data.y
      }
    }
  };
}

/**
 * 转换数据分布情况数据
 * 图表数据为空时返回null
 * @param {any} diffusion
 * @returns {object|null}
 */
export function convertDiffusionData(diffusion) {
  const makeOutlier = data => {
    return data.reduce((arr, item, i) => {
      arr = arr.concat(item.map(e => [i, e]));
      return arr;
    }, []);
  };
  if (!diffusion.dataList.length) return null;
  return {
    tips: diffusion.description,
    chartOpts: {
      xAxis: {
        data: diffusion.dimensions
      },
      series: [{ data: diffusion.dataList }, { data: makeOutlier(diffusion.abnormalList) }]
    }
  };
}

/**
 * 校验参数列表 移除空数组属性
 * @param {object} param 参数
 * @returns {object}
 */
export function validParam(param) {
  const newParam = {};
  let temp = null;
  Object.keys(param).forEach(key => {
    temp = param[key];
    if (Array.isArray(temp)) {
      if (temp.length) newParam[key] = temp;
    } else {
      newParam[key] = temp;
    }
  });
  return newParam;
}

export function imgsKeyParser(imgs) {
  const keys = Object.keys(imgs);
  if (keys.length) {
    return keys.reduce((map, key) => {
      const [sn, item] = key.split('-');
      if (sn !== 'undefined') {
        (map[sn] = map[sn] || {})[item] = imgs[key];
      } else {
        map[item] = imgs[key];
      }
      return map;
    }, {});
  }
  return {};
}
